import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import type { SetorWithVariedade } from "@shared/schema";

export function useSetores(opts?: { somenteProdutivos?: boolean }) {
  const { data, ...rest } = useQuery<SetorWithVariedade[]>({ queryKey: ["/api/setores"] });

  const setores = useMemo(() => {
    if (!data) return data;
    if (!opts?.somenteProdutivos) return data;
    return data.filter(s => (s.tipo ?? "PRODUTIVO") === "PRODUTIVO");
  }, [data, opts?.somenteProdutivos]);

  return { setores, ...rest };
}
